import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import Dialog from '@mui/material/Dialog';
import { Checkbox, DialogContent, DialogTitle, FormControl, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material';
import { usePatientReportMutation } from '~/api/patientReports/usePatientReportMutation';
import { CachedOutlined, Check, Close } from '@mui/icons-material';
import Button from '@mui/material/Button';
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
export const ConfirmInPersonAnalysisModal = (props) => {
    const { onRequestClose, reportID, sensorReview, providerNames, followUpDate, patientId, patient } = props;
    const [selectedDate, setSelectedDate] = React.useState(dayjs(new Date()));
    const [selectedFollowUpDate, setSelectedFollowUpDate] = React.useState(null);
    const [openFollowUpCalendar, setOpenFollowUpCalendar] = useState(false);
    const [personName, setPersonName] = React.useState([]);
    const [disableDoneButtonByDate, setDisableDoneButtonByDate] = useState(false);
    console.log('reportId');
    console.log(reportID);
    useEffect(() => {
        if (followUpDate) {
            setSelectedFollowUpDate(dayjs(followUpDate));
        }
    }, []);
    useEffect(() => {
        if (selectedDate) {
            // all practices need end of month disabled
            const lastDayOfMonth = selectedDate.endOf('month');
            if (selectedDate.isSame(lastDayOfMonth, 'day')) {
                if (patient.rpmConsent) {
                    setDisableDoneButtonByDate(true);
                }
                else {
                    setDisableDoneButtonByDate(false);
                }
            }
            else {
                setDisableDoneButtonByDate(false);
            }
            // some practices need more days disabled
            const dateToDisable = dayjs('2026-04-01');
            const dateToDisable1 = dayjs('2026-05-01');
            // these practice ids we do not want to disable on april 1 or may 1
            const practiceIdsToNotDisable = ['23', '30', '33', '34', '35', '36'];
            if (selectedDate.isSame(dateToDisable, 'day') || selectedDate.isSame(dateToDisable1, 'day')) {
                if (patient.practiceId) {
                    if (practiceIdsToNotDisable.includes(patient.practiceId)) {
                        setDisableDoneButtonByDate(false);
                    }
                    else {
                        if (patient.rpmConsent) {
                            setDisableDoneButtonByDate(true);
                        }
                        else {
                            setDisableDoneButtonByDate(false);
                        }
                    }
                }
            }
        }
    }, [selectedDate]);
    const { mutateAsync } = usePatientReportMutation();
    const methods = useForm({});
    const { formState: { isSubmitting }, handleSubmit } = methods;
    const onSubmit = async () => {
        await mutateAsync({
            id: reportID,
            offline: true,
            inOffice: true,
            glucoseSensorReview: sensorReview,
            didTalk: undefined,
            timeSpent: undefined,
            activityDate: selectedDate,
            supervisingProvider: personName[0],
            followUpDate: selectedFollowUpDate,
            programType: ''
        });
        sessionStorage.setItem("wasReloaded", "true");
        const storageKey = `patient-timer-${patientId}`;
        sessionStorage.removeItem(storageKey);
        window.location.reload();
    };
    const handleChange = (event) => {
        const { target: { value }, } = event;
        if (value[0] === personName[0]) {
            setPersonName([]);
        }
        else {
            setPersonName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value);
        }
    };
    return (React.createElement(Dialog, { open: true },
        React.createElement(DialogTitle, { sx: { m: 0, p: 2 }, id: "customized-dialog-title" },
            "Confirm Analysis",
            React.createElement("button", { style: { marginLeft: 'auto', float: 'right' }, onClick: onRequestClose },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { dividers: true },
            React.createElement(FormProvider, { ...methods },
                React.createElement("form", { onSubmit: handleSubmit(onSubmit), noValidate: true },
                    React.createElement("div", { className: "mb-5" },
                        React.createElement("div", { className: "flex justify-between items-center" },
                            React.createElement("div", { className: "pr-4" },
                                React.createElement("div", { className: "row" },
                                    "Are you sure you want to confirm analysis of this ",
                                    React.createElement("span", { className: "font-bold" }, "in-person"),
                                    " data review?")))),
                    React.createElement("div", null,
                        React.createElement("div", { className: "flex justify-between " },
                            React.createElement("div", { style: { width: '100%', marginBottom: '15px' } },
                                React.createElement("div", { style: { width: '100%', color: 'black', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600', wordWrap: 'break-word' } }, "Billing Provider:"),
                                React.createElement(Grid, { container: true },
                                    React.createElement(Grid, { item: true, xs: 6 },
                                        React.createElement(FormControl, { sx: { width: '100%', textAlign: 'left' }, size: "small" },
                                            React.createElement(InputLabel, { id: "demo-multiple-checkbox-label" }, "Select Billing Provider"),
                                            React.createElement(Select, { labelId: "demo-multiple-checkbox-label", id: "demo-multiple-checkbox", multiple: true, value: personName, onChange: handleChange, input: React.createElement(OutlinedInput, { label: "Tag" }), renderValue: (selected) => selected.join(', '), MenuProps: MenuProps, size: 'small' }, providerNames.map((name) => (React.createElement(MenuItem, { key: name, value: name },
                                                React.createElement(Checkbox, { checked: personName.indexOf(name) > -1 }),
                                                React.createElement(ListItemText, { primary: name })))))))))),
                        React.createElement("div", { className: "row", style: { marginTop: '10px', marginBottom: '10px' } },
                            React.createElement(Grid, { container: true },
                                React.createElement(Grid, { item: true, xs: 6 },
                                    React.createElement("div", { style: { color: 'black', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600' } }, "Activity Date:")),
                                React.createElement(Grid, { item: true, xs: 6 },
                                    React.createElement("div", { style: { display: 'flex' } },
                                        React.createElement("div", { style: { color: 'black', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600', marginRight: '10px' } }, selectedFollowUpDate ? 'Follow-Up Date (Optional)' : 'Follow-Up Date (Optional)'),
                                        React.createElement(CachedOutlined, { color: 'primary', onClick: () => setSelectedFollowUpDate(null) }))))),
                        React.createElement("div", { className: "row" },
                            React.createElement(Grid, { container: true },
                                React.createElement(Grid, { item: true, xs: 6 },
                                    React.createElement("div", { style: { width: '200px' } },
                                        React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                                            React.createElement(DatePicker, { value: selectedDate, maxDate: dayjs(), onChange: (value) => {
                                                    setSelectedDate(value);
                                                } })))),
                                React.createElement(Grid, { item: true, xs: 6 },
                                    React.createElement("div", { style: { width: '200px' } },
                                        React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                                            React.createElement(DatePicker, { open: openFollowUpCalendar, onOpen: () => setOpenFollowUpCalendar(true), onClose: () => setOpenFollowUpCalendar(false), slotProps: {
                                                    textField: {
                                                        onClick: () => setOpenFollowUpCalendar(true),
                                                    },
                                                }, value: selectedFollowUpDate, minDate: dayjs(), onChange: (value) => {
                                                    setSelectedFollowUpDate(value);
                                                } })))))),
                        React.createElement("div", { style: { display: disableDoneButtonByDate ? 'block' : 'none', color: 'var(--error-light, #EF5350)', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600', marginRight: 'auto', marginLeft: 'auto' } }, "Due to the billing calendar, data analysis cannot be completed today. Please register this activity as 'Other' or complete the data analysis tomorrow."),
                        React.createElement(Button, { style: { width: '100%', marginTop: '10px' }, variant: "contained", disabled: disableDoneButtonByDate ? true : isSubmitting, type: "submit", color: "primary", startIcon: React.createElement(Check, null) }, isSubmitting ? 'Confirming...' : 'Confirm Analysis')))))));
};
